<!-- This ngSwitch is a temporary solution to enable updating the Energiedirect cards without affecting Essent.
When we migrate Essent to the new component set, this switch will be disabled and all brands
will use the new variants currently used for ED only -->
@switch (brand) {
  @case ('ed') {
    @if (isSectionVariant(settings?.itemAlignment)) {
      <wl-basic-content-variant-media-section
        [content]="content"
        [settings]="settings"
        [context]="context"
        [image]="image"
        [rendering]="rendering"
        trackImpression="contentblock-impression"
        [trackImpressionInfo]="rendering"
        [trackImpressionContext]="context"
      >
      </wl-basic-content-variant-media-section>
    }
    @if (!isSectionVariant(settings?.itemAlignment)) {
      <wl-basic-content-variant-media-card
        [content]="content"
        [settings]="settings"
        [context]="context"
        [image]="image"
        [rendering]="rendering"
        [cardConfig]="cardConfig"
        trackImpression="contentblock-impression"
        [trackImpressionInfo]="rendering"
        [trackImpressionContext]="context"
      >
      </wl-basic-content-variant-media-card>
    }
  }
  @default {
    <wl-basic-content
      [variant]="variant"
      [content]="content"
      [settings]="settings"
      [context]="context"
      [image]="image"
      [rendering]="rendering"
      [cardConfig]="cardConfig"
      trackImpression="contentblock-impression"
      [trackImpressionInfo]="rendering"
      [trackImpressionContext]="context"
    >
    </wl-basic-content>
  }
}

<ng-container *wlShowInExperienceEditor>
  @if (!hasContent) {
    <div class="d-flex align-items-center justify-content-center bg-light p-2">
      <p class="m-0">BasicContent</p>
    </div>
  }
</ng-container>
